import React from 'react';
import './NavBar.css'
import Logo from '../Common/Logo';
import NavBtns from '../Common/NavBtns';

const NavBar = () => {
    return ( 
        <nav className='NavBar'>
            <Logo />
            <NavBtns />
        </nav>
     );
}
 
export default NavBar;